import React, { useState, useEffect,useRef } from "react";
import { useSelector,useDispatch } from "react-redux";
import ReCAPTCHA from "react-google-recaptcha"
import { Header, Input, Form, Button,Label } from "semantic-ui-react";
import { Formik, Field, Form as FormikForm } from "formik";
import {FormikInputComponent} from "../../../utilities/formUtils";

const Signup_Step_One = (props) => {  
    const onchangehandle = () =>{
        props.setEmailOnChangeTrigger("start");
        props.setEmailErrorClass("");
        props.setcustomEmailErrorMsg("");
        props.setEmailConsumedMsg("");
    }
    const onCaptachaChange = () =>{
        props.setCaptchaErrorClass("");
    }
    return(
        <div style={{display :props.displayparam}}>
            <div className="sign-up-head">
                <h3 className="signuptxt">Sign Up</h3>
            </div>
            <div className="sign-up-form-info">            
                <Form.Group widths={2}>
                    <div className="mb-3">
                        <label className="sign-up-field-name form-label">Email ID</label>
                        <Field
                            id="email"
                            name="email_id"
                            noLabel="y"
                            component={FormikInputComponent}
                            icontoShow = 'envelope'
                            iconPosition='left'
                            placeholder = "Enter your email id"
                            style={{marginTop:"11px"}}
                            className={props.emailErrorclass}
                            myChangeFunction = {onchangehandle}
                            iserror={props.emailErrorclass != "" ? true : false}
                            customErrorMsg = {props.customEmailErrorMsg}
                            />
                        <div className="otp-info">
                        {

                            props.emailConsumedMsg == "" ?                            
                                <p>OTP will be sent to the above email address</p>
                                :
                                <p className="consumedEmailError">{props.emailConsumedMsg}</p>
                            
                        }
                        </div>
                        <div className="capt-wrap">
                            <ReCAPTCHA
                                sitekey="6LcqH7IZAAAAAPOMwajJYKj-xe6WoX8-Y3aFew-I"
                                ref={props.captchaRef}
                                onChange={onCaptachaChange}
                            />
                            {
                                props.curCaptachaerrorClass == "error" ?
                                <Label size="mini" color='red' basic pointing prompt>Please mention you are not a robot</Label> 
                                :
                                <></>
                            }
                        </div>
                    </div>
                    </Form.Group>
                    
            </div>
        </div>
    )
}
export default Signup_Step_One;